import { useEffect, useRef } from 'react';

const normalizeId = (value) => (value === null || value === undefined ? null : String(value));

export default function useAppointmentRequestScope(practiceId, leadId) {
    const practiceKey = normalizeId(practiceId);
    const leadKey = normalizeId(leadId);
    const requestScopeRef = useRef(null);
    const { current } = requestScopeRef;

    if (!current || current.practiceId !== practiceKey || current.leadId !== leadKey) {
        requestScopeRef.current = {
            active: true,
            cancelWaits: new Set(),
            generation: (current?.generation || 0) + 1,
            latestRequestId: 0,
            practiceId: practiceKey,
            leadId: leadKey,
        };
    }

    useEffect(() => {
        const scope = requestScopeRef.current;
        return () => {
            scope.active = false;
            scope.generation += 1;
            scope.cancelWaits.forEach((cancelWait) => cancelWait());
            scope.cancelWaits.clear();
            if (requestScopeRef.current === scope) {
                requestScopeRef.current = scope;
            }
        };
    }, [practiceKey, leadKey]);

    return requestScopeRef;
}
